import { Injectable } from '@angular/core';
import { UserDTO } from '../model/UserDTO';
import { BehaviorSubject, Observable } from 'rxjs';

const USER = "currentUser"

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  public isChangeUser$ = new BehaviorSubject(false);
  public isChangeClient$ = new BehaviorSubject(false);

  constructor() { }

  setUser(user: UserDTO): void {
    localStorage.setItem(USER, JSON.stringify(user));
    this.setChangeUser();
  }

  getUser(): UserDTO {
    let user = localStorage.getItem(USER);
    if (user) {
      let user = new UserDTO();
      user.fillFromJSON(JSON.parse(localStorage.getItem(USER)));
      return user;
    }
    return new UserDTO();
  }

  isLogged(): boolean {
    var user = this.getUser();
    if (user && user.token) {
      return true;
    } else {
      return false;
    }
  }

  logout() {
    localStorage.setItem(USER, JSON.stringify(new UserDTO()));
  }

  public setChangeUser(): void {
    this.isChangeUser$.next(!this.isChangeUser$.getValue());
  }

  public getIsChangeUser(): Observable<boolean>{
    return this.isChangeUser$;
  }

  public setChangeClient(): void {
    this.isChangeClient$.next(!this.isChangeClient$.getValue());
  }

  public getIsChangeClient(): Observable<boolean>{
    return this.isChangeClient$;
  }


}
